import { CheckOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { message } from "antd";

export const showMessege = (messageType = "success", messageText = null, duration = 6) => {
  const messageStyles = `
  .ant-message .ant-message-notice-wrapper .ant-message-notice-content {
    background: ${messageType === "success" ? "#1bcdb7" : "#e42e37"} !important;
  }
`;

  if (typeof messageText === "string") {
    const styleElement = document.createElement("style");
    styleElement.innerHTML = messageStyles;
    document.head.appendChild(styleElement);
    message.open({
      content: (
        <p style={{ paddingTop: 3, paddingBottom: 3, margin: 0 }}>
          {messageType === "success" ? (
            <CheckOutlined />
          ) : (
            <InfoCircleOutlined />
          )}
          {" " + messageText}
        </p>
      ),
      duration: duration,
      // className: "toast",
      // className: "alertCLass",
    });
  }
};
